module.exports = __webpack_public_path__ + "static/media/ACT.9d2765ec.webp";